import { AnalyticsEvent, analyticsService } from '~/services/analytics';
import type { CartItem } from '~/stores/CartStore';
import type { Product } from '~/stores/CategoriesStore';

export const useCategoryAnalytics = () => {
  const handleClickCategory = (id: number | string, source?: string) => () => {
    analyticsService.track(AnalyticsEvent.CATALOG_CATEGORY_CLICKED, {
      id: `${id}`,
      source: source || '',
    });
    analyticsService.track(AnalyticsEvent.CATALOG_CATEGORY_CLICKED_BI, {
      id,
      source: source || '',
    });
    analyticsService.track(AnalyticsEvent.CATALOG_CATEGORY_VISITED_BI, {
      id,
      source: source || '',
    });
  };

  const handleClickProduct = (product: Product | CartItem) => () => {
    analyticsService.track(AnalyticsEvent.CATALOG_PRODUCT_CLICKED, product);
    analyticsService.track(AnalyticsEvent.CATALOG_PRODUCT_VISITED, product);
  };

  return {
    handleClickCategory,
    handleClickProduct,
  };
};
